export default __webpack_public_path__ + "static/media/van_icon.2ce50470.svg";